export default {"src":"/_next/static/media/peanutbutter.8e6c1eee.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};